import { translateFunc } from "client/utils/translateFunc";
import { Select } from "components/common/Select/Select";
import { DPIS, DPI as DPIType } from "store/types/dpi";
import { useDPI } from "./useDPI";

export const DPI = () => {
    const { dpi, handleChange } = useDPI();

    const DPIOptions: Record<DPIType, string> = {
        "10": "billboard",
        "72": "newspaper",
        "96": "screen",
        "150": "magazine",
        "200": "inkjet",
        "240": "inkjet",
        "300": "inkjet",
        "360": "inkjet",
        "600": "laser",
        "1200": "ultra-hires",
    };

    const getDPIOptions = (option: DPIType) =>
        `${option} ${translateFunc("dpi")} (${translateFunc(DPIOptions[option])})`;

    return (
        <div className="mt-4">
            <Select
                options={DPIS.map((d) => d)}
                label={translateFunc("dpi")}
                getOptionLabel={getDPIOptions}
                getOptionValue={(option) => option}
                handleClick={handleChange}
                value={dpi}
                description={translateFunc("dpi-desc")}
            />
        </div>
    );
};
